import { render } from "./AsesoriaDiseno.vue?vue&type=template&id=452d7659&scoped=true"
import script from "./AsesoriaDiseno.vue?vue&type=script&lang=js"
export * from "./AsesoriaDiseno.vue?vue&type=script&lang=js"

import "./AsesoriaDiseno.vue?vue&type=style&index=0&id=452d7659&scoped=true&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452d7659"]])

export default __exports__